export default {
  plurals: {
    filter: 'filter | filters',
  },
}
